import { createContext, useContext, type ReactNode } from 'react';

type RestaurantBrand = { name: string; symbol: ReactNode };
const RestaurantBrandContext = createContext<RestaurantBrand | null>(null);
export const RestaurantBrandProvider = ({ brand, children }: { brand: RestaurantBrand; children: ReactNode }) => (
  <RestaurantBrandContext.Provider value={brand}>{children}</RestaurantBrandContext.Provider>
);

/** The same brand signature across customer, login and service surfaces. */
export default function Brand({ subtitle }: { subtitle?: string }) {
  const brand = useContext(RestaurantBrandContext);
  return <div className="brand-signature">
    <span className="brand-symbol" aria-hidden="true">{brand?.symbol ?? <svg viewBox="0 0 32 40" fill="none"><path d="M8 19 16 35l8-16H8Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/><path d="m11 25 10-4M13 30l6-3M6 18c-3-4 0-9 4-9 0-7 12-7 12 0 5 0 7 6 4 9H6Z" fill="currentColor"/></svg>}</span>
    <span className="brand-copy"><span className="brand-wordmark" translate="no">{brand?.name ?? 'bamidi'}<span aria-hidden="true">.</span></span>{subtitle && <span className="brand-caption">{subtitle}</span>}</span>
  </div>;
}
